<div>
	<!-- <h2>
		<span jhiTranslate="bmsjHipsterApp.sample.home.title">Samples</span>-->
		<!--
		<button class="btn btn-primary float-end jh-create-entity create-sample" [routerLink]="['/', { outlets: { popup: ['sample-new'] } }]">
			<span class="fa fa-plus"></span>
			<span class="hidden-sm-down"  jhiTranslate="bmsjHipsterApp.sample.home.createLabel">
			Create new Sample
			</span>
		</button>
	</h2> -->
	<!-- TODO SEARCH -->
	<!--
	<div class="row">
		<div class="col-sm-12">
			<form name="searchForm" class="d-flex align-items-center">
				<div class="input-group w-100 mt-3">
					<input type="text" class="form-control" [(ngModel)]="currentSearch" id="currentSearch" name="currentSearch" placeholder="{{ 'bmsjHipsterApp.sample.home.search' | translate }}">
					<button class="input-group-append btn btn-info" (click)="search(currentSearch)">
						<span class="fa fa-search"></span>
					</button>
					<button class="input-group-append btn btn-danger" (click)="clear()" *ngIf="currentSearch">
						<span class="fa fa-trash-o"></span>
					</button>
				</div>
			</form>
		</div>
	</div>
	-->
	<br/>
	<!-- TODO IBP-4375
	<div class="row mb-3">
		<div class="col">
			<button class="btn btn-outline-info float-end" (click)="toggleListBuilder()">
				<i class="fa me-3" [ngClass]="listBuilderContext.visible ? 'fa-angle-right': 'fa-angle-left'"></i>
				<span *ngIf="listBuilderContext.visible" jhiTranslate="list-builder.hide"></span>
				<span *ngIf="!listBuilderContext.visible" jhiTranslate="list-builder.show"></span>
			</button>
		</div>
	</div>
	-->
	<div class="row">
        <div class="col-9">
            <span class="d-inline-flex p-2 h5 fw-bold">{{ 'study-editor.sample-list.title' | translate}}</span>: <span class="fst-italic value-chip-light">{{sampleList?.listName}}</span>
        </div>
		<div class="col-3 d-flex justify-content-end align-items-center">
			<div ngbDropdown placement="bottom-right">
				<button class="btn btn-info" id="actionMenu" ngbDropdownToggle>
					<span jhiTranslate="actions">Actions</span>
				</button>
				<div ngbDropdownMenu aria-labelledby="actionMenu">
					<button class="dropdown-item" type="submit" (click)="export()" jhiTranslate="bmsjHipsterApp.sample.actions.export-list">Export list
					</button>
					<button class="dropdown-item" type="submit" (click)="importPlate()" jhiTranslate="bmsjHipsterApp.sample.actions.import-plate-info">Import Plate Information
					</button>
					<button class="dropdown-item" type="submit" (click)="removeEntries()" jhiTranslate="bmsjHipsterApp.sample.actions.delete-samples">Delete Samples
					</button>
				</div>
			</div>
		</div>
	</div>
	<br/>

	<div class="row my-2">
		<div class="col d-flex align-items-center">
			<span class="me-1 fw-bold" jhiTranslate="global.total.entries" [translateValues]="{param: totalItems}"></span>
			<span class="ms-3 me-1 fw-bold" jhiTranslate="global.selected"></span>
			<span>{{this.size()}}</span>
		</div>
	</div>
	<div class="table-responsive" *ngIf="sampleList.samples">
		<table class="table table-striped table-curved">
			<thead>
			<tr jhiSort [(predicate)]="predicate" [(ascending)]="reverse" [callback]="transition.bind(this)">
				<th>
					<input type="checkbox" class="form-check-input" [ngbTooltip]="'global.select.current.page' | translate" [checked]="isPageSelected()" (click)="onSelectPage()" [title]="'global.select.current.page' | translate" />
				</th>
				<th jhiSortBy="entryNo"><span jhiTranslate="bmsjHipsterApp.sample.entryNo">SAMPLE_ENTRY</span><span class="fa fa-sort"></span></th>
				<th *jhiHasAnyAuthority="VIEW_NAMES_PERMISSION" jhiSortBy="designation"><span jhiTranslate="bmsjHipsterApp.sample.designation">DESIGNATION</span><span class="fa fa-sort"></span> </th>
				<th jhiSortBy="gid"><span jhiTranslate="bmsjHipsterApp.sample.gid">GID</span><span class="fa fa-sort"></span> </th>
				<th jhiSortBy="sampleName"><span jhiTranslate="bmsjHipsterApp.sample.sampleName">SAMPLE_NAME</span><span class="fa fa-sort"></span> </th>
				<th jhiSortBy="takenByUserId"><span jhiTranslate="bmsjHipsterApp.sample.takenBy">TAKEN_BY</span><span class="fa fa-sort"></span> </th>
				<th jhiSortBy="samplingDate"><span jhiTranslate="bmsjHipsterApp.sample.samplingDate">SAMPLING_DATE</span><span class="fa fa-sort"></span> </th>
				<th jhiSortBy="sampleBusinessKey"><span jhiTranslate="bmsjHipsterApp.sample.sampleBusinessKey">SAMPLE_UID</span><span class="fa fa-sort"></span> </th>
				<th jhiSortBy="plateId"><span jhiTranslate="bmsjHipsterApp.sample.plateId">SAMPLE_ID</span><span class="fa fa-sort"></span> </th>
				<th jhiSortBy="well"><span jhiTranslate="bmsjHipsterApp.sample.well">WELL</span><span class="fa fa-sort"></span> </th>
			</tr>
			</thead>
			<tbody cdkDropList cdkDropListConnectedTo="listBuilderDrop">
			<tr *ngFor="let sample of sampleList.samples; trackBy: trackId; index as index"
                (click)="toggleSelect($event, index, sample); $event.stopPropagation()"
				[class.selected]="isSelected(sample)"
                (mousedown)="preventDefaultOnShiftKey($event)"
				cdkDrag [cdkDragDisabled]="!listBuilderContext.visible" (cdkDragEntered)="dragStart($event, sample)">
				<div *cdkDragPlaceholder>&nbsp;</div>

				<td><input type="checkbox" class="form-check-input" [checked]="isSelected(sample)" (click)="toggleSelect($event, index, sample, true); $event.stopPropagation()"></td>
				<td>
					<!--<a (click)="$event.stopPropagation()" [routerLink]="['../sample', sample.id ]">{{sample.id}}</a>-->
					{{sample.entryNo}}
				</td>
				<td *jhiHasAnyAuthority="VIEW_NAMES_PERMISSION"><truncate-span [textInput]="sample.designation" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></td>
                <td><truncate-span [textInput]="sample.gid"></truncate-span></td>
				<td><truncate-span [textInput]="sample.sampleName"></truncate-span></td>
				<td>{{sample.takenBy}}</td>
				<!--<td>{{sample.samplingDate | date:'medium'}}</td>-->
				<td>{{sample.samplingDate}}</td>
				<td><truncate-span [textInput]="sample.sampleBusinessKey"></truncate-span></td>
				<td><truncate-span [textInput]="sample.plateId"></truncate-span></td>
				<td><truncate-span [textInput]="sample.well"></truncate-span></td>
				<!-- TODO ACTIONS -->
				<!--
				<td class="text-end">
					<div class="btn-group flex-btn-group-container">
						<button type="submit"
						 (click)="$event.stopPropagation()"
								[routerLink]="['../sample', sample.id ]"
								class="btn btn-info btn-sm">
							<span class="fa fa-eye"></span>
							<span class="d-none d-md-inline" jhiTranslate="entity.action.view">View</span>
						</button>
						<button type="submit"
						 (click)="$event.stopPropagation()"
								[routerLink]="['/', { outlets: { popup: 'sample/'+ sample.id + '/edit'} }]"
								replaceUrl="true"
								queryParamsHandling="merge"
								class="btn btn-primary btn-sm">
							<span class="fa fa-pencil"></span>
							<span class="d-none d-md-inline" jhiTranslate="entity.action.edit">Edit</span>
						</button>
						<button type="submit"
						 (click)="$event.stopPropagation()"
								[routerLink]="['/', { outlets: { popup: 'sample/'+ sample.id + '/delete'} }]"
								replaceUrl="true"
								queryParamsHandling="merge"
								class="btn btn-danger btn-sm">
							<span class="fa fa-remove"></span>
							<span class="d-none d-md-inline" jhiTranslate="entity.action.delete">Delete</span>
						</button>
					</div>
				</td>
				-->
			</tr>
			</tbody>
		</table>
	</div>
	<div *ngIf="sampleList.samples && sampleList.samples.length">
		<div class="row">
			<div class="col">
				<div class="pagination-container">
					<div class="pagination-box pagination-box-left">
						<div>
							<jhi-item-count [page]="page" [total]="queryCount" [itemsPerPage]="itemsPerPage"></jhi-item-count>
						</div>
					</div>
					<div class="pagination-box">
						<ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage"
										[maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
					</div>
					<div class="pagination-box pagination-box-right">
						<div class="d-flex align-items-center">
							<label for="itemsPerPage" class="control-label control-label-left" jhiTranslate="global.items.per.page"></label>
							<select [(ngModel)]="itemsPerPage" class="form-select ms-2" id="itemsPerPage" (change)="loadAll(); listBuilderContext.pageSize = itemsPerPage" style="width:95px">
								<option value="20">20</option>
								<option value="50">50</option>
								<option value="75">75</option>
								<option value="100">100</option>
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
